<template>
  <div class="chart-filters">
    <div class="chart-filters__options">
      <FilterSelect
        v-if="hasDateFilters"
        label="Período"
        :value="filters[ChartFiltersKeys.DATE_FILTER].value"
        :options="filters[ChartFiltersKeys.DATE_FILTER].options"
        use-option-label
        :menu-allowed-placements="['bottom-start', 'bottom-end']"
        :disabled="isLoading"
        @change="
          value => emitOnSelectFilter(ChartFiltersKeys.DATE_FILTER, value)
        "
      />
      <FilterSelect
        v-if="hasBenchmarkFilters"
        label="Benchmark"
        :value="filters[ChartFiltersKeys.BENCHMARK_FILTER].value"
        :options="filters[ChartFiltersKeys.BENCHMARK_FILTER].options"
        use-option-label
        :menu-allowed-placements="['bottom-start', 'bottom-end']"
        :disabled="isLoading"
        @change="
          value => emitOnSelectFilter(ChartFiltersKeys.BENCHMARK_FILTER, value)
        "
      />
      <SpinnerLoader
        v-if="isLoading"
        :size="16"
        :color="NebraskaColors.elementPlaceholder"
        data-testid="chart-filters-loader"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

import { FilterSelect, SpinnerLoader } from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/MoneyV2';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { ChartFiltersTypes, ChartFiltersKeys } from './types';

@Component({
  components: {
    FilterSelect,
    SpinnerLoader,
    Money
  }
})
export default class ChartFilters extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly isLoading!: boolean;

  @Prop({ type: Object, required: true })
  readonly filters!: ChartFiltersTypes;

  readonly NebraskaColors = NebraskaColors;
  readonly ChartFiltersKeys = ChartFiltersKeys;

  @Emit('on-select-filter')
  emitOnSelectFilter(_filterKey: ChartFiltersKeys, _value: string | number) {}

  get hasBenchmarkFilters() {
    return this.filters[ChartFiltersKeys.BENCHMARK_FILTER].options.length > 0;
  }

  get hasDateFilters() {
    return this.filters[ChartFiltersKeys.DATE_FILTER].options.length > 0;
  }
}
</script>

<style lang="less" scoped>
.chart-filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: @size-spacing-x600;
  margin-bottom: @size-spacing-x300;
  flex-wrap: wrap;

  &__profit {
    display: flex;
    flex-direction: column;
  }

  &__options {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    & > * {
      margin-right: @size-spacing-x300;
    }

    & > *:last-child {
      margin-right: 0;
    }
  }
}
</style>
